// @it-enterprise пакеты
import graphQlCore from '@/plugins/graphQlCore'
import registerAppRuntime from '@/plugins/appRuntime.js'
// vue пакеты
import Vue from 'vue'
import axios from './plugins/axios'
import { i18n } from './plugins/i18n'
import store from './store'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import router from './router'
import vuetify from '@/plugins/vuetify'
import './registerServiceWorker.js'
import microflow from './plugins/microflow/index'
import objectModel from './plugins/objectModel'

document.title = i18n.t('general.loading')

// обратная совместимость с параметром с некорректным ключём который был ранее актуален
if (!window.appConfig.GraphQlUrl && window.appConfig.GrapgQlUrl) {
  window.appConfig.GraphQlUrl = window.appConfig.GrapgQlUrl
  console.warn(i18n.t('general.oldGraphQLKey'))
}

// объект с зависимостями
let dependencies = {
  i18n,
  // apolloProvider,
  axios,
  store,
  router
}

// Плагины стандартные
Vue.use(Vuelidate)

// Плагины it-enterprise
Vue.use(graphQlCore)
Vue.use(microflow, { dependencies })
Vue.use(objectModel)


import drError from './components/customWidgets/dr-error.vue'

Vue.component('dr-error', drError)
// импорт компонентов
let req = require.context('@/components/', true, /\.(js|vue)$/i)
req.keys().map(key => {
  if (!(req(key).default || {}).name) {
    return
  }
  Vue.component(req(key).default.name, req(key).default)
})

// импорт макетов
req = require.context('@/layout/', true, /\.(js|vue)$/i)
req.keys().map(key => {
  if (!(req(key).default || {}).name) {
    return
  }
  Vue.component(req(key).default.name, req(key).default)
})

req = require.context('@/mainMenuSrc/layout/', true, /\.(js|vue)$/i)
req.keys().map(key => {
  if (!(req(key).default || {}).name) {
    return
  }
  Vue.component(req(key).default.name, req(key).default)
})


registerAppRuntime().then(() => {
  mergeThemeColors(vuetify.framework.theme.themes.light, Vue.prototype?.$Personalization?.Colors)
  
  // Удаление индикатора загрузки после инициализации приложения
  document.querySelector('.loader-wrapper').style.display = 'none'

  new Vue({
    i18n,
    router,
    store,
    vuetify,
    // apolloProvider,
    render: h => h(App)
  }).$mount('#app')
})

// Замена vuetify палитры на пользовательскую
function mergeThemeColors(vuetifyColors, personalizationColors) {
  if (!personalizationColors) {
    return
  }
  for (let i in vuetifyColors) {
    if (personalizationColors[i]) {
      vuetifyColors[i] = personalizationColors[i]
    }
  }
}